import { limitedTimeOffer } from './limited-time-offer';
import { personalShopper } from './personal-shopper';
import { socialProofMessenger } from './social-proof-messenger';
import { leadMagnetDelivery } from './lead-magnet-delivery';

// Export all amplify marketing playbooks
export const amplifyMarketingPlaybooks = [
  limitedTimeOffer,
  personalShopper,
  socialProofMessenger,
  leadMagnetDelivery,
];

// Export individual playbooks for direct import
export { 
  limitedTimeOffer,
  personalShopper,
  socialProofMessenger,
  leadMagnetDelivery
};